import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'gpt-3.5-turbo-instruct',
  'gpt-3.5-turbo-instruct-0914',
  'text-davinci-003',
  'text-davinci-002',
  'text-davinci-001',
  'text-curie-001',
  'text-babbage-001',
  'text-ada-001',
  'davinci',
  'curie',
  'babbage',
  'ada',
].map((value) => ({ label: value, value }));

export const DEFAULT_MODEL = 'gpt-3.5-turbo-instruct';

export function useOpenAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferOpenAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null
): SerializedConstructor | null {
  if (params?.ls_provider !== 'openai' || params?.ls_model_type !== 'text') {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'llms', 'openai', 'OpenAI'],
    kwargs: {
      model: params.ls_model_name,
      temperature: params.ls_temperature,
      max_tokens: params.ls_max_tokens,
    },
  };
}
